import styled, { css } from 'styled-components';
import { rgba } from 'polished';

// Import styles
import { flex, customMinResponsive, size } from 'components/styles';

export const Total = styled.div`
	${flex({ jc: 'space-between' })}
	margin-top: 1.5rem;
	gap: 2rem;
	color: ${({ theme }) => theme.configurator.color.primary};
	font-size: 1.5rem;

	${customMinResponsive(
		size.semi,
		css`
			font-size: 1.8rem;
		`
	)}
`;

export const Info = styled.div`
	${flex()}
	gap: 0.2em;
	max-width: 45%;
	font-weight: ${({ theme }) => theme.font.light};

	p {
		font-weight: ${({ theme }) => theme.font.light};
	}

	${customMinResponsive(
		400,
		css`
			max-width: 55%;
		`
	)};
`;

export const Wrapper = styled.div`
	${flex({ jc: 'space-between', ai: 'flex-start' })}
	font-size: 1.4rem;
	line-height: 1.2em;
	color: ${({ theme }) => rgba(theme.configurator.color.primary, 0.7)};
	font-weight: ${({ theme }) => theme.font.light};
	white-space: pre-line;
	margin-top: 1.2rem;
`;
